import { Component, Input, OnInit, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-live-clock',
  template: `<div class="clock">
               🕒 {{ displayTime }}
              </div>
              `,
  styleUrls: []
})
export class ClockComponent implements OnInit, OnDestroy, OnChanges {
  @Input() utcDateTime!: string; // example: '2025-11-01T11:38:31.1563677Z'

  localDate!: Date;
  displayTime: string = '';
  timer: any;

  ngOnInit() {
    this.syncBaseDate();
    this.startClock();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['utcDateTime']) {
      this.syncBaseDate();
      this.updateClock();
    }
  }

  private syncBaseDate() {
    const parsed = this.utcDateTime ? new Date(this.utcDateTime) : new Date();
    this.localDate = Number.isNaN(parsed.getTime()) ? new Date() : parsed;
  }

  private startClock() {
    this.updateClock();
    this.timer = setInterval(() => {
      this.localDate = new Date(this.localDate.getTime() + 1000);
      this.updateClock();
    }, 1000);
  }

  updateClock() {
    // Step 3: Format local time nicely
    // this.displayTime = this.localDate.toLocaleString('en-IN', {
    //   weekday: 'short',
    //   day: '2-digit',
    //   month: 'short',
    //   year: 'numeric',
    //   hour: '2-digit',
    //   minute: '2-digit',
    //   second: '2-digit',
    //   hour12: true,
    //   timeZoneName: 'short'
    // });

     // ✅ Format: DD/MM/YYYY HH:MM:SS
    const dd = String(this.localDate.getDate()).padStart(2, '0');
    const mm = String(this.localDate.getMonth() + 1).padStart(2, '0');
    const yyyy = this.localDate.getFullYear();

    const hh = String(this.localDate.getHours()).padStart(2, '0');
    const min = String(this.localDate.getMinutes()).padStart(2, '0');
    const ss = String(this.localDate.getSeconds()).padStart(2, '0');

    this.displayTime = `${dd}/${mm}/${yyyy} ${hh}:${min}:${ss}`;
  }

  ngOnDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
}
